export default "__VITE_ASSET__a96c609e__"